const tvRecommendation = {
    questionArray: [],
    recommendedTV: '',
    tvRecommendationChecked: '',
    radioChecked: '',
    enableButton: false
}
//define a reducer with an initialized state action
function customTvRecommendation(state = tvRecommendation, action) {
    //eventually adding logic to handle create, update, and delete
    switch (action.type) {
        case 'PUSH_QUESTION':
            let index = state.questionArray.findIndex(el => el.id === action.value.id);
            let currentQuestionArr = state.questionArray;
            let updatedQuestionArr = [];
            if (index < 0) {
                updatedQuestionArr = currentQuestionArr.concat(action.value)
            }
            let temp = [];
            
            if (updatedQuestionArr !== undefined && updatedQuestionArr != null && updatedQuestionArr.length > 0) {
                temp.push(updatedQuestionArr[0]);
                updatedQuestionArr.map(ques => {
                    if (state.tvRecommendationChecked.indexOf("|") !== -1) {
                        let selID = state.tvRecommendationChecked.split('|');
                        for (let i = 0; i < selID.length; i++) {
                            if (selID[i] !== "") {
                                if (ques.id !== undefined && ques.id !== null && ques.id === selID[i]) {
                                    temp.push(ques)
                                }
                            }
                        }
                    }
                    else {
                        if (undefined !== ques.id && null !== ques.id && ques.id === state.tvRecommendationChecked) {
                            temp.push(ques)
                        }
                    }
                })
            }
            if (temp.length > 0)
                return Object.assign({}, state, {
                   // questionArray: state.questionArray.concat(action.value)
                   questionArray: temp
                })
           return state;
        case 'POP_QUESTION':
            let quesIndex = state.questionArray.findIndex(el => el.id === action.value);
            if (quesIndex > -1)
                return Object.assign({}, state, {
                    questionArray: state.questionArray.filter((item, index) => index !== quesIndex)
                })
            return state;
        case 'CLEAR_QUESTIONS':
                let remTV = state.recommendedTV;
                // if (remTV === "PREFERRED") {
                //     remTV = '';
                // }
            return Object.assign({}, state, {
                questionArray: [],//state.questionArray.pop(action.value)
                tvRecommendationChecked: '',
                radioChecked:'',
                enableButton: false,
                recommendedTV: remTV
            })
        case 'UPDATE_RECOMMENDED_TV':
            return Object.assign({}, state, {
                recommendedTV: action.value
            })
        case 'UPDATE_PREFERRED_RECOMMENDED_TV':
            let recomTv = state.recommendedTV;
            if (recomTv === "PREFERRED") {
                recomTv = ''
            }
            return Object.assign({}, state, {
                recommendedTV: recomTv
            })
        case 'UPDATE_TVRECOM_CHECKED':
            return Object.assign({}, state, {
                tvRecommendationChecked: action.value
            })
        case 'UPDATE_RADIO_CHECKED':
            return Object.assign({}, state, {
                radioChecked: action.value
            })
        case 'UPDATE_QUESTION_ARRAY':
            let idStr = state.tvRecommendationChecked;
            let questionArr = state.questionArray;
            let tempArr = [];
            tempArr.push(questionArr[0]);
            questionArr.map(ques => {
                if (idStr.indexOf("|") !== -1) {
                    let selID = idStr.split('|');
                    for (let i = 0; i < selID.length; i++) {
                        if (selID[i] !== "") {
                            if (ques.id !== undefined && ques.id !== null && ques.id === selID[i]) {
                                tempArr.push(ques)
                            }
                        }
                    }
                } else {
                    if (undefined !== ques.id && null !== ques.id && ques.id === idStr) {
                        tempArr.push(ques)
                    }
                }
            })
            
           // state.questionArray.pop();
            return Object.assign({}, state, {
                questionArray: tempArr
            })
        case 'ENABLE_BUTTON':
            return Object.assign({}, state, {
                enableButton: action.value
            })
        default:
            return state
    }
}

export default customTvRecommendation